<template>
    <div>
        <Vueditor ref="editor" @change="() => testEditor($e)"></Vueditor>
        <button @click="testEditor">click See Console</button>
    </div>
</template>
<script>
export default {
    mounted() {
        this.test();
    },
    methods: {
        testEditor() {
            const editor = this.$refs.editor;
            let content = editor.getContent();
            console.log(content);
        },
        test() {
            const editor = this.$refs.editor;
            editor.setContent("<h1>Content this</h1>");
            console.log(this.$refs.editor);
        }
    }
};
</script>
